import { useEffect, useState } from "react";
import MovementService from "../../services/movementService";

// Hooks
import useUser from '../user/useUser';
import useQueryString from '../queryString/useQueryString';

const initFilters = {
    pageNumber: 1,
    pageSize: 10,
    state: 'all',
    type: 'all',
    subType: 'all',
    reason: '',
    from: '',
    to: '',
    numberReferral: ''
}

const useMovements = (defaultFilters) => {
    const { branch } = useUser();
    const [searchResult, setSearchResult] = useState({ movements: [], totalPage: 1 });
    const [loading, setLoading] = useState(false);
    const { filters, search, setParameterSearch, clearFilters } = useQueryString({ ...initFilters, ...defaultFilters });

    useEffect(() => {
        const requiredFields = ['state', 'type', 'subType'];
        const missing = requiredFields.some(k => !filters?.[k]);
 
        if (missing) {
            setParameterSearch({
                ...initFilters,
                ...filters
            });
        }
    }, []);
    
    useEffect(() => {
        const searchMovements = () => {
            setLoading(true);
            MovementService
                .Search({ ...filters, warehouseId: branch.warehouseId })
                .then(res => setSearchResult({
                    movements: res.values,
                    totalPage: res.totalPage
                }))
                .finally(() => setLoading(false));
        }

        if (branch.warehouseId && !loading)
            searchMovements();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filters, branch?.warehouseId]);

    return {
        ...searchResult,
        loading,
        filters,
        search,
        setParameterSearch,
        clearFilters
    }
}

export default useMovements;